import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';

const INSWING_OPTIONS = [
  { value: 'Brass',                                        label: 'Brass'                                          },
  { value: 'FlatBlack',                                    label: 'Flat Black'                                     },
  { value: 'OilRubbed',                                    label: 'Oil Rubbed'                                     },
  { value: 'StainlessSteel',                               label: 'Stainless Steel'                                },
  { value: 'BlackChrome',                                  label: 'Black Chrome'                                   },
  { value: 'SatinNikel',                                   label: 'Satin Nikel'                                    },
  { value: 'SelfClosingZinc',                              label: 'Self-Closing (Zinc)'                            },
  { value: 'AdjustableHingeBlack',                         label: 'Adjustable Hinge Black'                        },
  { value: 'AdjustableHingeSatinNikel',                    label: 'Adjustable Hinge Satin Nikel'                  },
  { value: 'AdjustableHingeBlackBrass',                    label: 'Adjustable Hinge Black Brass'                  },
  { value: 'ContemporarySquareBarrelHingesFlatBlack',      label: 'Contemporary Square Barrel Hinges Flat Black'   },
  { value: 'ContemporarySquareBarrelHingesSatinNikel',     label: 'Contemporary Square Barrel Hinges Satin Nikel'  },
  { value: '3WayAdustableConcealedBlackHinges',            label: '3-Way Adustable Concealed Black Hinges'         },
];

const OUTSWING_OPTIONS = [
  { value: 'StainlessSteel', label: 'Stainless Steel' },
];

const HingeFinish = ({ value = { value: '', label: '' }, onChange, disabled = false, swing }) => {
  const [selected, setSelected] = useState(value?.value || '');

  const options = swing?.value === 'Inswing' ? INSWING_OPTIONS : OUTSWING_OPTIONS;

  // Sync from parent (e.g. load from DB) — skip if swing just reset us
  const skipValueSync = useRef(false);
  useEffect(() => {
    if (skipValueSync.current) { skipValueSync.current = false; return; }
    setSelected(value?.value || '');
  }, [value?.value]);

  // When swing changes, clear selection if the current value is no longer valid
  useEffect(() => {
    if (selected && !options.find(o => o.value === selected)) {
      skipValueSync.current = true;
      setSelected('');
      onChange({ value: '', label: '' });
    }
  }, [swing?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = options.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdHingeFinish">Hinge Finish</label>
      <select id="SdHingeFinish" value={selected} onChange={handleChange} disabled={disabled}>
        {options.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default HingeFinish;
